// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var HhsStatus;
(function (HhsStatus) {
    HhsStatus["AlreadyEnrolled"] = "AlreadyEnrolled";
    HhsStatus["Enrolled"] = "Enrolled";
    HhsStatus["Expired"] = "Expired";
    HhsStatus["Rejected"] = "Rejected";
    HhsStatus["Unknown"] = "Unknown";
})(HhsStatus || (HhsStatus = {}));
//# sourceMappingURL=hhsStatus.js.map